<div class="product-types-wrapper">
  <h6>Product:</h6>
  <ng-select
    [items]="productTypes"
    [multiple]="true"
    bindLabel="name"
    [closeOnSelect]="false"
    [clearable]="true"
    [(ngModel)]="selectedProductTypes"
    placeholder="Filter by Product"
    notFoundText="No product found"
    (ngModelChange)="onChange()">
    <ng-template ng-option-tmp let-item="item" let-item$="item$">
      <input type="checkbox" [checked]="item.checked" />
      <span class="name">{{ item.name }}</span>
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items">
      <div class="ng-value" *ngIf="items.length === 1">
        <span class="ng-value-label">{{ items[0].name }}</span>
      </div>
      <div class="ng-value" *ngIf="items.length > 1">
        <span class="ng-value-label">{{ items.length }} product(s) selected</span>
      </div>
    </ng-template>
  </ng-select>
</div>
